"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
exports.__esModule = true;
var media_provider_1 = require("./media-provider");
var media_1 = require("./media");
__export(require("./media-provider"));
__export(require("./media"));
function createMediaProvider(mediaFactory, payload, providerInstance) {
    return new media_provider_1.MediaProvider(mediaFactory, payload, providerInstance);
}
exports.createMediaProvider = createMediaProvider;
function createMedia(payload) {
    if (payload === void 0) { payload = {}; }
    return new media_1.MediaModel(payload);
}
exports.createMedia = createMedia;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@qwentes/models/lib/packages/media/index.js
// module id = 253
// module chunks = 0